import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { ExternalModule } from './container/external/external.module';
import { InternalModule } from './container/internal/internal.module';

const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'external'
  }
  ,
  {
    path: 'internal',
    // component: ContainerComponent,
    loadChildren: () => InternalModule
  },
  {
    path: 'external',
    // component: ContainerComponent,
    loadChildren: () => ExternalModule
  },
  {
    path: '**',
    // component: ExternalComponent,
    redirectTo: 'external/passarela'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
    enableTracing: false,
    preloadingStrategy: PreloadAllModules // <- Precarga de rutas
})
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
